module.exports = __webpack_public_path__ + "static/media/menu-proposals-blue.a557f7f6.svg";